// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aria-feedback[data-v-46cacc7c]{text-indent:-10000px;font-size:.1px}", ""]);
// Exports
module.exports = exports;
